<div id="content" class="main-content">
    <div class="container">
        <div class="page-header ">
            <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between ">
                <h2 class="col-sm-12 col-xs-12">
                    <i class="flaticon-list2"></i><b> Enquêtes de satisfaction</b>
                </h2>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col col-lg-12">
                    <div class="row" id="cancel-row" >
                        <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                            <div class="statbox widget box box-shadow">
                                <div class="widget-header">
                                    <div class="row">       
                                    </div>
                                </div>
                                <div class="widget-content widget-content-area pl-0 pr-1">
                                    <div *ngIf="enqueteLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                                    <div class="table-responsive mb-4" *ngIf="!enqueteLoading">
                                        <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                            <thead>
                                              <tr>
                                                <th>N° de l'enquête</th>
                                                <th>Nom de l'enquête</th>
                                                <th>Nombre de question</th>
                                                <th>Dernière date d'envoi</th>
                                                <th>Dernier destinataire</th>
                                                <th>Dernière date de réponse</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let survey of allsurveys">
                                                <td>
                                                    {{ survey.survey_code || '- - -'}}
                                                </td>
                                                <td>
                                                    {{ survey.survey_name || '- - -'}}
                                                </td>
                                                <td>
                                                    {{ survey.survey_questions || '- - -'}}
                                                </td>
                                                <td>
                                                    {{ (survey.survey_last_sent_at | date: 'dd/MM/yyyy- HH\'H\'mm') || 'Pas encore envoyé!' }}
                                                </td>
                                                <td>
                                                    {{ survey_last_sent_to || 'Aucun destinataire' }}
                                                </td>
                                                <td>
                                                    {{ (survey.survey_last_response_at | date: 'dd/MM/yyyy- HH\'H\'mm') || 'Aucune date de réponse' }}
                                                </td>
                                                <td class="d-flex justify-content-center">
                                                    <a type="button" class="btn btn-gradient-dark" style="background-image: linear-gradient(to right,#47adfa 0,#517fa4 100%);padding: 1% 3%;"  [routerLink]="'/survey-detail/' + survey.survey_uuid">
                                                        <i class="flaticon-view-2"></i> Consulter
                                                    </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </div>        
        </div>
    </div>
</div>